import React, { Component } from "react";

import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';

//material ui components
import Grid from '@material-ui/core/Grid';
import Moment from 'moment';

//material components
import Paper from '@material-ui/core/Paper';

//menuItems

class ModalMultipleDeleteActivities extends Component {
    constructor(props) {
        super();
        this.state = {
            open: false,
            //Resize
            rootFontSize: {
                name: 'xs',
                fontSize: '58%',
                maxWidht: 970,
            },
        };
    }

    componentWillMount() {
        window.addEventListener("resize", this.resize.bind(this));
        this.resize();
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.resize.bind(this));
    }

    resize() {

        const sizes = {
            xs: {
                name: 'xs',
                fontSize: '58%',
                maxWidht: 600,
            },
            sm: {
                name: 'sm',
                fontSize: '60%',
                maxWidht: 1024,
            },
            md: {
                name: 'md',
                fontSize: '80%',
                maxWidht: 1880,
            },
            lg: {
                name: 'lg',
                fontSize: '100%',
                maxWidht: 1920,
            },
        };

        const windowWidht = window.innerWidth;
        const windowHeiht = window.innerHeight;

        let rootFontSize = sizes.xs;

        if (windowWidht > sizes.md.maxWidht) {
            rootFontSize = sizes.lg;
        } else if (windowWidht > sizes.sm.maxWidht) {
            rootFontSize = sizes.md;
        } else if (windowWidht > sizes.xs.maxWidht) {
            rootFontSize = sizes.sm;
        } else {
            rootFontSize = sizes.xs;
        }


        this.setState({
            rootFontSize: rootFontSize,
            windowWidht: windowWidht,
            windowHeiht: windowHeiht,
        });
    }


    //#region  Handlers 
    CleanScheduleModal = () => {

    };
    //#endregion

    //#region  Inner components

    RenderModalContent = () => {

        return (
            <Grid>
                <Paper elevation={3} className="paperModalMultipleDeleteActivities" square='false' color='secondary'>
                    <Grid id='menu_item_deletetion_modal' container justify='flex-start' alignItems='baseline' style={{ height: '100%' }} >
                        <Grid item container>
                            <Grid item justify='center' style={{ width: '100%' }} alignItems='center'>
                                <this.RenderTitleContainer />
                            </Grid>
                            <Grid item justify='center' alignItems='center' style={{ paddingTop: '30px' }}>
                                <this.RenderMessageContainer />
                            </Grid>
                            <Grid item container className="ModalButtonsContainer alingCenter" style={{ paddingTop: '30px' }} justify='flex-end'>
                                <this.RenderButtonsContainer />
                            </Grid>
                        </Grid>
                    </Grid>
                </Paper>
            </Grid>
        );
    };


    RenderButtonsContainer = () => {
        return (
            <Grid item container className="alingCenter" direction='row'>
                <Grid item xs={10}>
                    <Grid item container direction='row-reverse'>
                        <Grid item container className="VoiceSettingModalButtonYes redbtn2-engage alingCenter">
                            <Grid id='close_repair_close_btn' item container className="alingCenter" onClick={() => this.props.OnDeleteMultipleHandler()}>
                                Yes, Delete
                            </Grid>
                        </Grid>
                        <Grid item container className="VoiceSettingModalButtonCancel alingCenter">
                            <Grid id='close_repair_return_btn' item container className="alingCenter" onClick={() => this.props.OnCancelHandler()}>
                                No, Cancel
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        );
    };

    RenderMessageContainer = () => {
        const currentData = this.props.selectedActivities;
        return (
            <Grid item container className="alingCenter" direction='row'>
                <Grid item xs={10} >
                    {/* Activity Delete List */}
                    <Grid container alignItems='center' className="titleEngageStyleHeadersBook" style={{ padding: '0px 10px' }} >
                        <Grid item md={2} lg={2}>Image</Grid>
                        <Grid item md={3} lg={3} style={{ paddingLeft: (window.innerWidth >= 1280 && window.innerWidth < 1600) ? '10px' : '0px' }}>
                            Activity
                        </Grid>
                        <Grid item md={2} lg={2}>
                            Category
                        </Grid>
                        <Grid item md={3} lg={3}>
                            Date
                        </Grid>
                        <Grid item md={2} lg={2} style={{ textAlign: (window.innerWidth < 1400) ? 'center' : 'left' }}>
                            Registrations
                        </Grid>
                    </Grid>
                    <Grid container className="ModalActivityList"> 
                        {
                            currentData && currentData.map((item, index) => {
                                const startDateObj = item.date ? new Date(new Date(item.date).toLocaleString("en-US", { timeZone: this.props.currentCommunity?.timeZoneName })) : undefined;
                                const endDateObj = item.endDate ? new Date(new Date(item.endDate).toLocaleString("en-US", { timeZone: this.props.currentCommunity?.timeZoneName })) : undefined;


                                //For residents de-register 
                                let attendees = (item.attendees) ? item.attendees.length : 0;

                                if (attendees > 0) {
                                    item.attendees.forEach(item => {
                                        if (item.subscribed === false)
                                            attendees--;
                                    });
                                }

                                return (
                                    <Grid id={`Activity_row_${item._id}`} container key={item._id} alignItems='center' justify='flex-start'
                                        className="rowEngageStyleList" onClick={(e) => { this.handleEdit(e, item); }} style={{ padding: '0px 10px', color: '#F0EFEF' }}
                                    >
                                        <Grid id={`activityRow_thumbnail`} item container xs={12} sm={12} md={2} lg={2} style={{ display: 'flex' }} ><this.ThumbnailImage alt={index} url={item.thumbnailImageUrl ? item.thumbnailImageUrl : (item.backgroundUrl ? item.backgroundUrl : '')} /></Grid>
                                        <Grid id={`activityRow_title`} item xs={12} sm={12} md={3} className="rowEngageStyle "
                                            style={{ paddingLeft: (window.innerWidth >= 1280 && window.innerWidth < 1600) ? '10px' : '0px' }}>
                                            {item.title ? item.title : 'no title'}
                                        </Grid>
                                        <Grid id={`activityRow_category`} item xs={12} sm={12} md={2} className="rowEngageStyle ">{(item.category && item.category.name) ? item.category.name : 'no category'}</Grid>
                                        <Grid id={`activityRow_date`} item xs={12} sm={12} md={2} lg={3} className="rowEngageStyle" >
                                            <Grid className="rowEngageStyle">{Moment(startDateObj).format("MMM DD, YYYY")}</Grid>
                                            <Grid className="rowEngageStyle">{`${Moment(startDateObj).format('LT')} - ${Moment(endDateObj).format('LT')}`}</Grid>
                                        </Grid>
                                        <Grid id={`activityRow_attendees`} item xs={12} sm={12} md={2} lg={2} className="rowEngageStyle" style={{ textAlign: (window.innerWidth < 1400) ? 'center' : 'left' }}>
                                            {`${attendees}/${(item.maxAttendees ? item.maxAttendees : 'unlimited')}`}
                                        </Grid>
                                    </Grid>
                                )
                            })
                        }
                    </Grid>
                </Grid>
                <Grid item xs={10} className="DeleteMultipleModalFooter">
                    <Grid>For recurring activities, this will delete only the occurrence(s) selected. To delete all instances of a recurring activity, open an instance of an activity and you will have the option to delete only the selected occurrence or all occurrences.</Grid>
                </Grid>
            </Grid>
        );
    };

    RenderTitleContainer = () => {
        return (
            <>
                <Grid item container xs={12} direction='row-reverse'>
                    <div className="engage-nav VoiceTitleModal" onClick={() => this.props.OnCancelHandler()}>
                        <img
                            src='https://engage360.s3.amazonaws.com/Icons/circle-xmark.svg'
                            alt='close'
                            className="closeIcon"
                            height="35px"
                        />
                    </div>
                </Grid>
                <Grid item container className="alingCenter" direction='row'>
                    <Grid item xs={10} className="MultipleDeleteModalTitle">
                        <Grid>Are you sure you want to delete the following {this.props.totalActivities} activities?</Grid>
                    </Grid>
                </Grid>
            </>
        );
    }
    //#endregion

    //ThumbnailImage
    ThumbnailImage = (
        {
            height = '70px',
            width = '110px',
            alt,
            url
        }
    ) => {
        return (
            <img
                alt={'Thumbnail ' + alt}
                style={{ borderRadius: '10px', margin: '', maxWidth: '100%', objectFit: 'cover' }}
                width={width}
                height={height}
                src={url}
            >
            </img>
        );
    };

    render() {
        return (
            <main style={{}}>
                <div>
                    <this.RenderModalContent />
                </div>
            </main>
        )
    }
}

function mapStateToProps(state, dispatch) {

    return {
    }
}


ModalMultipleDeleteActivities = reduxForm({
    form: 'ModalMultipleDeleteActivitiesForm',
    enableReinitialize: true,
})(ModalMultipleDeleteActivities);

export default connect(mapStateToProps, {})(ModalMultipleDeleteActivities);

